import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// The etn type-scale utilities (globals.css --text-etn-*) share the `text-`
// namespace with colors. Without this, twMerge classifies them as colors and
// silently drops them whenever a text color appears later in the list —
// `cn('text-etn-control', 'text-white/70')` lost the font size.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': ['text-etn-control', 'text-etn-control-sm', 'text-etn-cell', 'text-etn-micro']
    }
  }
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
